<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Subject Consolidated Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
              getStandardCourse();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="c_id"
                        :items="crs_list" item-text="course" label="Course" outlined
                        @change="getassessmentschemedetails()" persistent-hint hint="Please select course"
                        @click="putnull2" />
                </v-col>
                <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_detail" return-object
                        :items="assessment_detail_list" item-text="assessmenttype" label="Assessment Scheme Details"
                        outlined multiple persistent-hint hint="Please select assessment scheme details"
                        @click="putnull3" />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div && crs_id && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center">
                <span v-if="learner_course_list != null">
                    <span v-if="show">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                        <!-- excel btn code -->

                        <!-- list data- <br />{{ bookList1 }} <br /><br /> -->


                        <v-btn rounded class="no-display" color="success" outlined @click="
                  fnExcelReport('my-table-id', 'SubjectConsolidatedReport')
                " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>


                        <!-- excel export btn code end -->
                        <!-- <v-row dense justify="center">
                        <v-col cols="12" sm="2" md="2" align="right">
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_2.jpeg" width="75%" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                            <center>
                                <br />
                                <strong><h6>PIMPRI CHINCHWAD EDUCATION TRUST`S</h6></strong>
                                <strong>S.B. PATIL PUBLIC SCHOOL, RAVET</strong><br />
                                 <strong><h5>Subject Consolidated Sheet ({{academicyear}})</h5></strong><br />
                            </center>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" align="left">
                            <br />
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_1.jpeg" width="50%" alt="logo" />
                        </v-col>
                    </v-row> -->
                        <v-row dense align="center" class="mt-4" style="width: 100%;">
                            <!-- Left Logo -->
                            <v-col cols="12" sm="4" md="2" class="text-left" style="padding-left: 25px;">
                                <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" alt="Trust Logo"
                                    style="height: 150px;" />
                            </v-col>

                            <!-- Center Text -->
                            <v-col cols="12" sm="4" md="8" class="text-center">
                                <h2 style="margin: 0; font-size: 26px; font-weight: 700;">
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h3 style="margin: 0; font-size: 22px; font-weight: 600;">
                                    {{ org_basic_data.school_name }}
                                </h3>
                                <h4 style="margin: 8px 0 0 0; font-size: 18px; font-weight: 500;">
                                    Subject Consolidated Sheet ({{ academicyear }})
                                </h4>
                            </v-col>

                            <!-- Right Logo -->
                            <v-col cols="12" sm="4" md="2" class="text-right" style="padding-right: 25px;">
                                <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo"
                                    alt="School Logo" style="height: 150px;" />
                            </v-col>
                        </v-row>

                        <div id="my-table-id">
                            <v-col cols="12" sm="12" md="12">
                                <v-row dense justify="center">
                                    <v-col cols="12" sm="3" md="3">
                                        <strong>
                                            <h5>Class : {{ standard }} {{ division }}</h5>
                                        </strong>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <strong>
                                            <h5>Course : {{ course }}</h5>
                                        </strong>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <strong>
                                            <h5>
                                                Exam : <br />
                                                <span v-for="(header, index) in ass_detail_list" :key="header"> {{ index
                                                    + 1 }}.{{ header }}<br /> </span>
                                            </h5>
                                        </strong>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <strong>
                                            <h5>Teacher : {{ inst_name }}</h5>
                                        </strong>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table fixed-header dense class="elevation-1">
                                    <thead>
                                        <tr>
                                            <th class="">
                                                <center>Sr. No.</center>
                                            </th>
                                            <th class="">
                                                <center>Roll No.</center>
                                            </th>
                                            <th class="">
                                                <center>Registration No.</center>
                                            </th>
                                            <th class="">
                                                <center>Name</center>
                                            </th>
                                            <th class="" v-for="header in ass_detail_list" :key="header">
                                                <center>{{ header }}</center>
                                            </th>
                                            <!-- <th class="" v-for="header in atotal" :key="header">
                                    <center>Total {{ header }}</center>
                                </th>
                               <th class="" v-for="header in ass_converted_total" :key="header">
                                    <center>{{ header }}</center>
                                </th>  -->
                                            <!--<th><center>{{ass_detail_list[0]}}}</center></th>  -->
                                            <th>
                                                <center>Total ({{ atotal[0] }})</center>
                                            </th>
                                            <!-- <th><center>{{ass_converted_total[0]}} %</center></th> -->
                                            <th>
                                                <center>%</center>
                                            </th>
                                            <th class="">
                                                <center>Grade</center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in learner_course_list" :key="s.cid">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ s.rollno }}</td>
                                            <td>{{ s.registration_number }}</td>
                                            <td>{{ s.name }}</td>
                                            <td v-for="(header, index) in s.comp_marks" :key="index">
                                                <center>{{ header }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.levaluated_marks }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.converted_marks }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.grade }}</center>
                                            </td>
                                            <!-- <td>
                                    <center>--</center>
                                </td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <br /><br /><br /><br /><br />
                                <!-- Add a new row-like structure below the table -->
                                <v-row dense class="mt-8" style="width: 100%; align-items: center;">
                                    <!-- Left: Subject Teacher -->
                                    <v-col cols="4" class="text-left" style="padding-left: 40px;">
                                        <strong>Subject Teacher</strong>
                                    </v-col>

                                    <!-- Center: Exam Incharge -->
                                    <v-col cols="4" class="text-center">
                                        <strong>Exam Incharge</strong>
                                    </v-col>

                                    <!-- Right: Principal -->
                                    <v-col cols="4" class="text-right" style="padding-right: 40px;">
                                        <strong>Principal</strong>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </div>
                    </span>
                </span>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            Breadcrumbs,
        },
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                standard: null,
                division: null,
                course: null,
                ass_Scheme: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: null,
                inst_name: null,
                atotal: null,
                ass_converted_total: null,
                show: false,
                org_basic_data: [],
                default_value: null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },

        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            myfunction() {
                for (var i = 0; i < this.learner_course_list.length; i++) {
                    // var formattter = this.learner_course_list[i].converted_marks.toFixed(2)
                    var formattter = Math.round(this.learner_course_list[i].converted_marks);
                    //  alert(formattter)
                    //this.learner_course_list[i].converted_marks = formattter
                    //return
                }
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                    div: this.div,
                    ass_id: this.assessment_detail,
                    status: this.status,
                };
                this.fetch_loader = true;
                axios
                    .post("/Examination/getsubjectconsolidatedreport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.division = res.data.div;
                            this.course = res.data.course;
                            this.ass_Scheme = res.data.ass_Scheme;
                            this.academicyear = res.data.ay;
                            this.ass_detail_list = res.data.ass_detail_list;
                            this.learner_course_list = res.data.learner_course_list;
                            this.default_value = res.data.default_value;
                            //this.myfunction()
                            if (this.default_value == "True") {
                                for (var i = 0; i < this.learner_course_list.length; i++) {
                                    this.learner_course_list[i].converted_marks = Math.round(this.learner_course_list[i].converted_marks);
                                    this.learner_course_list[i].levaluated_marks = Math.round(this.learner_course_list[i].levaluated_marks);
                                    //  for(var j=0;i<this.learner_course_list[i].comp_marks.length;j++){
                                    //     this.learner_course_list[i].comp_marks[j] = Math.round(this.learner_course_list[i].comp_marks[j])
                                    //  }
                                }
                            }
                            this.inst_name = res.data.inst_name;
                            this.atotal = res.data.atotal;
                            this.ass_converted_total = res.data.ass_converted_total;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                            this.show = true;
                        }
                        if (res.data.flag == "NO") {
                            this.standard = res.data.standard;
                            this.division = res.data.div;
                            this.course = res.data.course;
                            this.ass_Scheme = res.data.ass_Scheme;
                            this.academicyear = res.data.ay;
                            this.ass_detail_list = res.data.ass_detail_list;
                            this.learner_course_list = res.data.learner_course_list;
                            this.default_value = res.data.default_value;
                            if (this.default_value == "True") {
                                for (var i = 0; i < this.learner_course_list.length; i++) {
                                    this.learner_course_list[i].converted_marks = Math.round(this.learner_course_list[i].converted_marks);
                                    this.learner_course_list[i].levaluated_marks = Math.round(this.learner_course_list[i].levaluated_marks);
                                    //  for(var j=0;i<this.learner_course_list[i].comp_marks.length;j++){
                                    //     this.learner_course_list[i].comp_marks[j] = Math.round(this.learner_course_list[i].comp_marks[j])
                                    //  }
                                }
                            }
                            this.inst_name = res.data.inst_name;
                            this.atotal = res.data.atotal;
                            this.ass_converted_total = res.data.ass_converted_total;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                            this.show = true;
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                            // this.fetch_loader = false
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => { });
            },
            getassessmentschemedetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getassessmentschemewithoutrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
            },
            getStandardCourse() {
                // let div = this.div.div_id;
                // if (this.div.div_id) {
                //     div = this.div.div_id;
                // } else {
                //     div = this.div;
                // }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                };
                axios
                    .post("/Examination/getStandardCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                // this.div_list = ["All"];
                // this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                // this.div_list.unshift("All");
                //this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }

    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }

    @media (min-width: 320px) {

        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td+td,
        th+th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }

    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }

    .t-row {
        padding: 1rem i !important;
    }

    .mytable /deep/ thead th {
        background: #0f2027 !important;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }

    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }

    .delete-avatar:hover {
        background-color: transparent;
    }

    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }

    .delete-v-icon:hover {
        color: white;
    }

    .v-dialogss {
        bottom: 880;
        right: 0;
    }

    @media print {

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }

        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }

        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important;
        }

    }

    .trust-logo {
        width: 50%;
        padding-right: 10px;
    }

    .schl-logo {
        width: 50%;
        padding-left: 10px;
    }
</style>